<template>
  <v-col class="ma-0 pa-0" cols="12">
    <v-row class="ma-0 pa-0 mt-10">
      <v-col class="ma-0 pa-0" align="left" style="font-size:0.8rem">
        <v-row class="ma-0 pa-0" align="center">
          <template v-if="anonymousDisplayEnable">
            {{'来客人数/'}}
          </template>
          {{'顔認識データ取得数'}}
        </v-row>
      </v-col>
      <v-row class="ma-0 pa-0 mr-1" justify="end" style="font-size:0.8rem">
        <template v-if="anonymousDisplayEnable">
          <v-img class="ma-0 pa-0 mr-2" max-height="1.2rem" max-width="1.2rem"
                 src="@/assets/images/light_grey_box.png"></v-img>
          {{ta('unacquiredNumber')}}
        </template>
        <v-img class="ma-0 pa-0 ml-5 mr-2" max-height="1.2rem" max-width="1.2rem"
               src="@/assets/images/yellow_box.png"></v-img>
        {{ta('numberOfAcquisitions')}}
      </v-row>
    </v-row>
    <AnalyticsChart :mode="mode" :fetchLoading="fetchLoading"
                    :monthNoData="monthNoData" :chartData="visitorDataset"
                    :chartOptions="visitorChartOption" :visitorData="visitorData" />

    <v-row class="ma-0 pa-0 mt-5">
      <v-col class="ma-0 pa-0" align="left" style="font-size:0.8rem">
        <v-row class="ma-0 pa-0" align="center">
          <v-col class="ma-0 pa-0" cols="3">
            {{ta('manAndWoman')}}
          </v-col>
          <v-col class="ma-0 pa-0 pl-3" cols="3">
            <v-row class="ma-0 pa-0" align="center">
              <input id="check_box" type="checkbox" v-model="showAgeManAndWoman" />
              <v-col class="ma-0 pa-0 ml-3" cols="auto">{{'年代別を表示'}}</v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-row class="ma-0 pa-0 mr-1" justify="end" style="font-size:0.8rem">
        <v-img class="ma-0 pa-0 mr-2" max-height="1.2rem" max-width="1.2rem"
               src="@/assets/images/blue_box.png"></v-img>
        {{ta('man')}}
        <v-img class="ma-0 pa-0 ml-5 mr-2" max-height="1.2rem" max-width="1.2rem"
               src="@/assets/images/pink_box.png"></v-img>
        {{ta('woman')}}
      </v-row>
    </v-row>
    <AnalyticsChart :mode="mode" :fetchLoading="fetchLoading"
                    :monthNoData="monthNoData" :chartData="genderDataset"
                    :chartOptions="genderChartOption" :visitorData="visitorData"
                    :showAge="true" :showAgeValue="showAgeManAndWoman" :manOrWoman="true" />

    <v-row class="ma-0 pa-0 mt-5">
      <v-col class="ma-0 pa-0" align="left" style="font-size:0.8rem">
        <v-row class="ma-0 pa-0" align="center">
          <v-col class="ma-0 pa-0" cols="3">
            {{ta('newOrRepeatCustomers')}}
          </v-col>
          <v-col class="ma-0 pa-0 pl-3" cols="3">
            <v-row class="ma-0 pa-0" align="center">
              <input id="check_box" type="checkbox" v-model="showAgeNewOrRepeatCustomers" />
              <v-col class="ma-0 pa-0 ml-3" cols="auto">{{'年代別を表示'}}</v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-row class="ma-0 pa-0 mr-1" justify="end" style="font-size:0.8rem">
        <v-img class="ma-0 pa-0 mr-2" max-height="1.2rem" max-width="1.2rem"
               src="@/assets/images/green_box.png"></v-img>
        {{ta('repeatCustomer')}}
        <v-img class="ma-0 pa-0 ml-5 mr-2" max-height="1.2rem" max-width="1.2rem"
               src="@/assets/images/purple_box.png"></v-img>
        {{ta('new')}}
      </v-row>
    </v-row>
    <AnalyticsChart :mode="mode" :fetchLoading="fetchLoading"
                    :monthNoData="monthNoData" :chartData="repeaterDataset"
                    :chartOptions="repeaterChartOption" :visitorData="visitorData"
                    :showAge="true" :showAgeValue="showAgeNewOrRepeatCustomers" :manOrWoman="false" />
    <AnalyticsDownload v-show="(period == '30day' || period == 'fromto') ? totalVisitData : (visitorData.length != 0 || !monthNoData)"
                       :modeData="downloadMode" :periodData="downloadPeriod"
                       :startDate="startDate" :endDate="endDate" @totalVisitorData="totalVisitorDataFunc"
                       :pageName="pageName" :leftSide="leftSide" />
  </v-col>
</template>

<script>
import mixin from '@/mixin';
import AnalyticsChart from '@/components/AnalyticsChart.vue';
import * as Option from '@/components/chartOptions';
import AnalyticsDownload from '@/components/AnalyticsDownload.vue';
import alanyticsMixin from '@/mixin/analytics';
import {GENDER_DATASET_INIT, REPEATER_DATASET_INIT, VISITOR_DATASET_INIT} from '@/constants';
export default {
  props: {
    mode: String,
    period: String,
    downloadMode: String,
    downloadPeriod: String,
    startDate: undefined,
    endDate: undefined,
    leftSide: Object,
    params: Object,
    axisNum: Number,
    unisCustomerCd: String,
  },
  components: {
    AnalyticsDownload,
    AnalyticsChart

  },
  mixins: [mixin.common, alanyticsMixin],
  data: () => ({
    visitorChartOption: Option.VisitorOption,
    genderChartOption: Option.GenderChartOption,
    repeaterChartOption: Option.RepeaterChartOption,
    visitorMax: 100,
    genderMax: 100,
    repeaterMax: 100,
    anonymousDisplayEnable: true,
    pageName: 'storeAnalyze',
    totalVisitData: false,
    fetchLoading: false,
    monthNoData: true,
    emptyData: false,
    showAgeManAndWoman: false,
    showAgeNewOrRepeatCustomers: false,
    manAndWomanRatioList: [],
    manAndWomanRatioTempList: [],
    newOrRepeatCustomersRatioList: [],
    newOrRepeatCustomersRatioTempList: [],
    hourList: [],
    dateList: [],
    weekList: [],
    visitorData: [],
    visitorDataset: VISITOR_DATASET_INIT,
    genderDataset: GENDER_DATASET_INIT,
    repeaterDataset: REPEATER_DATASET_INIT,
  }),
  computed: {
    modeType: function () {
      return this.$store.state.analyticsModeType;
    },
  },
  watch: {
    params: {
      deep: true,
      handler(val, oldVal) {
        this.fetchVisitorData();
      }
    },
    mode(item) {
      this.visitorChartOption.scales.yAxes[0].ticks.max = 100;
      this.visitorChartOption.scales.yAxes[0].ticks.stepSize = 50;
      this.genderChartOption.scales.yAxes[0].ticks.max = 100;
      this.genderChartOption.scales.yAxes[0].ticks.stepSize = 50;
      this.repeaterChartOption.scales.yAxes[0].ticks.max = 100;
      this.repeaterChartOption.scales.yAxes[0].ticks.stepSize = 50;
    },
    showAgeManAndWoman(item) {
      if (item) {
        this.manAndWomanRatioTempList = [...this.genderDataset.labels];
        this.genderDataset.labels = this.manAndWomanRatioList;
      } else {
        this.genderDataset.labels = [...this.manAndWomanRatioTempList];
      }
    },
    showAgeNewOrRepeatCustomers(item) {
      if (item) {
        this.newOrRepeatCustomersRatioTempList = [...this.repeaterDataset.labels];
        this.repeaterDataset.labels = this.newOrRepeatCustomersRatioList;
      } else {
        this.repeaterDataset.labels = [...this.newOrRepeatCustomersRatioTempList];
      }
    }
  },
  created() {
    this.anonymousDisplayEnable = this.$store.getters.getAnonymousDisplayEnable;
  },
  mounted() {
    this.fetchVisitorData();
  },
  methods: {
    ta(t) {
      return this.$t("lang.allStoreAnalytics." + t);
    },
    async fetchVisitorData() {
      this.fetchLoading = true;
      this.monthNoData = true;
      this.emptyData = false;
      this.showAgeManAndWoman = false;
      this.showAgeNewOrRepeatCustomers = false;
      this.weekList = await this.makeAxisWeekList(this.params.from, this.axisNum);
      this.dateList = await this.makeAxisDateList(this.params.from, this.axisNum);
      this.hourList = await this.makeAxisHourList(this.leftSide, this.axisNum, 'chart');
      this.networkController.getAnalyticsVisitors({}, this.mode, this.params.from, this.params.to, this.unisCustomerCd)
        .then(async (res) => {
          console.log('%cVisitorData\n', "color:#008DD0;", res.data);
          this.visitorData = res.data;
          if (this.mode == this.modeType.WEEK || this.mode == this.modeType.MONTH || this.mode == this.modeType.THREE) {
            for (let i = 0; i < this.axisNum; i++) {
              let item = res.data[i];
              if (item.Data.total != 0) {
                this.monthNoData = false;
                this.emptyData = true;
              }
            }
          }
          this.visitorDataset.datasets[0].data = [];
          this.visitorDataset.datasets[1].data = [];
          this.visitorDataset.labels = [];
          this.genderDataset.datasets[0].data = [];
          this.genderDataset.datasets[1].data = [];
          this.genderDataset.labels = [];
          this.manAndWomanRatioList = [];
          this.repeaterDataset.datasets[0].data = [];
          this.repeaterDataset.datasets[1].data = [];
          this.repeaterDataset.labels = [];
          this.newOrRepeatCustomersRatioList = [];
          if (res.data.length != 0) {
            this.totalCountCalculate(res.data, this.mode);
            if (this.mode == this.modeType.HOUR) {
              this.hourList.forEach((hour) => {
                let hourIndex = res.data.findIndex((el, idx, arr) => el.start == hour);
                let item = res.data[hourIndex];
                this.makeChart(hourIndex, item);
              });
            } else if (this.mode == this.modeType.DAY) {
              this.dateList.forEach((date) => {
                let dataIndex = res.data.findIndex((el, idx, arr) => el.start == date);
                let item = res.data[dataIndex];
                this.makeChart(dataIndex, item);
              })
            } else if (this.mode == this.modeType.WEEK) {
              this.weekList.forEach((week) => {
                let weekIndex = res.data.findIndex((el, idx, arr) => el.start == week);
                let item = res.data[weekIndex];
                this.makeChart(weekIndex, item);
              })
            } else { // month, three
              for (let i = 0; i < this.axisNum; i++) {
                let item = res.data[i];
                this.makeChart(i, item);
              }
            }
            setTimeout(() => {
              let visitor1DataMax = Math.max(...this.visitorDataset.datasets[0].data);
              let visitor2DataMax = Math.max(...this.visitorDataset.datasets[1].data);
              this.visitorMax = this.anonymousDisplayEnable ? this.getMaxValue(visitor1DataMax + visitor2DataMax) : this.getMaxValue(visitor1DataMax);              this.visitorChartOption.scales.yAxes[0].ticks.max = this.visitorMax;
              this.visitorChartOption.scales.yAxes[0].ticks.stepSize = this.visitorMax / 2;

              let genderData1Max = Math.max(...this.genderDataset.datasets[0].data);
              let genderData2Max = Math.max(...this.genderDataset.datasets[1].data);
              this.genderMax = this.getMaxValue(genderData1Max + genderData2Max);
              this.genderChartOption.scales.yAxes[0].ticks.max = this.genderMax;
              this.genderChartOption.scales.yAxes[0].ticks.stepSize = this.genderMax / 2;

              let repeaterData1Max = Math.max(...this.repeaterDataset.datasets[0].data);
              let repeaterData2Max = Math.max(...this.repeaterDataset.datasets[1].data);
              this.repeaterMax = this.getMaxValue(repeaterData1Max + repeaterData2Max);
              this.repeaterChartOption.scales.yAxes[0].ticks.max = this.repeaterMax;
              this.repeaterChartOption.scales.yAxes[0].ticks.stepSize = this.repeaterMax / 2;
            }, 100);
          } else {
            this.$store.commit('setAnalyticsPeopleCountList', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
            this.emptyData = true;
          }
          this.fetchLoading = false;
        }).catch(error => {
        this.fetchLoading = false;
      });
    },
    totalCountCalculate(data, mode) {
      let totalPeoPleCountList = [];
      if (mode == this.modeType.HOUR) {
        this.hourList.forEach((hour) => {
          let hourIndex = data.findIndex((el, idx, arr) => el.start == hour);
          if (data[hourIndex] == undefined) {
            totalPeoPleCountList.push(0);
          } else {
            if(this.anonymousDisplayEnable) {
              totalPeoPleCountList.push(data[hourIndex].Data.total);
            } else {
              totalPeoPleCountList.push(data[hourIndex].Data.known);
            }
          }
        });
        setTimeout(() => {
          this.$store.commit('setAnalyticsPeopleCountList', totalPeoPleCountList);
        }, 100);
      } else if (mode == this.modeType.DAY) {
        this.dateList.forEach((date, resIndex, array) => {
          let dataIndex = data.findIndex((el, idx, arr) => el.start == date);
          let item = data[dataIndex];
          if (dataIndex != -1) {
            if(this.anonymousDisplayEnable) {
              totalPeoPleCountList.push(item.Data.total);
            } else {
              totalPeoPleCountList.push(item.Data.known);
            }
          }
          if (dataIndex == -1) {
            totalPeoPleCountList.push(0);
          }
          if (resIndex == array.length - 1) {
            this.$store.commit('setAnalyticsPeopleCountList', totalPeoPleCountList);
          }
        });
      } else if (mode == this.modeType.WEEK) {
        this.weekList.forEach((week) => {
          let weekIndex = data.findIndex((el, idx, arr) => el.start == week);
          if (data[weekIndex] == undefined) {
            totalPeoPleCountList.push(0);
          } else {
            if(this.anonymousDisplayEnable) {
              totalPeoPleCountList.push(data[weekIndex].Data.total);
            } else {
              totalPeoPleCountList.push(data[weekIndex].Data.known);
            }
          }
        });
        setTimeout(() => {
          this.$store.commit('setAnalyticsPeopleCountList', totalPeoPleCountList);
        }, 100);
      } else { // month, three
        data.forEach((analytics, resIndex, array) => {
          let cnt = this.anonymousDisplayEnable ? analytics.Data.total : analytics.Data.known;
          totalPeoPleCountList.push(cnt);
          if (resIndex == array.length - 1) {
            this.$store.commit('setAnalyticsPeopleCountList', totalPeoPleCountList);
          }
        });
      }
    },
    totalVisitorDataFunc(data) { //그래프에 보이지 않는 구간도 데이터가 있으면 파일 다운로드 표시
      this.networkController.getAnalyticsVisitors({}, this.mode, data.fileDownloadFrom, data.fileDownloadTo, this.unisCustomerCd)
        .then(async (res) => {
          console.log(res.data.length);
          if (res.data.length != 0) {
            this.totalVisitData = true;
          } else {
            this.totalVisitData = false;
          }
        })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>